import Bugsnag from '@bugsnag/js'

Bugsnag.start({
  apiKey: process.env.BUGSNAG_API_KEY,
  // enabledReleaseStages: ['production', 'development'],
  releaseStage: process.env.NODE_ENV
})

const email = localStorage.getItem('email')
const name = localStorage.getItem('name')
const familyName = localStorage.getItem('family_name')

if (email) {
  Bugsnag.setUser(email, email, `${name || ''} ${familyName || ''}`.trim())
}

export default {
  send: (error) => {
    Bugsnag.notify(error)
  }
}



// WEBPACK FOOTER //
// ./src/services/Bugsnag.js